import { ReactNode } from "react";
import { Icon } from "../icon/icon";

interface InfoCardProps {
  leftIcon?: string;
  leftClassName?: string;
  title?: string;
  text?: string;
  rightIcon?: string;
  className?: string;
  rightElement?: ReactNode;
}

export const InfoCard: React.FC<InfoCardProps> = ({
  leftIcon = "",
  leftClassName = "",
  title = "",
  text = "",
  rightIcon = "",
  className = "",
  rightElement,
}) => {
  return (
    <div
      className={`flex w-full gap-4 rounded-2xl bg-light-green p-4 text-left text-sm text-primary md:items-center ${className}`}
    >
      {leftIcon && (
        <Icon
          svg={leftIcon}
          width={24}
          height={24}
          className={`min-w-fit ${leftClassName}`}
        />
      )}

      <div className="flex-1">
        <p className="font-bold">{title}</p>
        <p className="mt-[2px] text-grey-900">{text}</p>
      </div>

      {rightIcon && (
        <Icon svg={rightIcon} width={24} height={24} className="min-w-fit" />
      )}

      {rightElement}
    </div>
  );
};
